import axios from "axios";
import API from "./api";
import router from "@/router";


export default {
  getTrainerCoordinator() {
    return API().get(`trainers/${router.currentRoute.params.id}/coordinator`);
  },

  getGroupCoordinator() {
    return API().get(`groups/${router.currentRoute.params.id}/coordinator`);
  },

  getGroupTrainer() {
    return API().get(`groups/${router.currentRoute.params.id}/trainer`);
  },

  //teacher calls
  getTeacherCoordinator() {
    return API().get(`teachers/${router.currentRoute.params.id}/coordinator`);
  },

  getTeacherTrainer() {
    return API().get(`teachers/${router.currentRoute.params.id}/trainers`);
  },

  getTeacherGroup() {
    return API().get(`teachers/${router.currentRoute.params.id}/groups`);
  },

  getTeacherSchool() {
    return API().get(`teachers/${router.currentRoute.params.id}/schools`);
  },

  //student calls
  getStudentCoordinator() {
    return API().get(`students/${router.currentRoute.params.id}/coordinator`);
  },

  getStudentTrainer() {
    return API().get(`students/${router.currentRoute.params.id}/trainer`);
  },

  getStudentGroup() {
    return API().get(`students/${router.currentRoute.params.id}/group`);
  },

  getStudentSchool() {
    return API().get(`students/${router.currentRoute.params.id}/school-teacher`);
  },

  getStudentTeacher() {
    return API().get(`students/${router.currentRoute.params.id}/school-teacher`);
  },
};